export default "__VITE_ASSET__BkXYT8Re__"